import ChatRoomLayout from '@/components/layouts/chatroom-layout';
import useSessionEffect from '@/hooks/conversations/use-session-effect';
import useGroupSocketEvents from '@/hooks/groups/use-group-socket-events';
import { useMessageStore } from '@/stores/message';
import { parseSessionKey } from '@/utils/session';

export default function GroupMessagesLayout() {
  const id = useMessageStore((s) => parseSessionKey(s.key ?? '')[1]);
  useSessionEffect('group', id);
  useGroupSocketEvents(id);

  return <ChatRoomLayout type='group' />;
}
